// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Hamburger_texte__3BYi- {\n  color: #157c84;\n}\n.Hamburger_item__21mgR {\n  padding: 14px 0px;\n}\n.Hamburger_exit__Nhx7o {\n  margin-top: 4px;\n}\n", "",{"version":3,"sources":["webpack://src/Navigation/Hamburger/Hamburger.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB","sourcesContent":[".texte {\n  color: #157c84;\n}\n.item {\n  padding: 14px 0px;\n}\n.exit {\n  margin-top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"texte": "Hamburger_texte__3BYi-",
	"item": "Hamburger_item__21mgR",
	"exit": "Hamburger_exit__Nhx7o"
};
export default ___CSS_LOADER_EXPORT___;
